
export let ServiceEndpoint
if (process.env.NODE_ENV === 'production') {
  ServiceEndpoint = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''
    }`
} else {
  ServiceEndpoint = `${window.location.protocol}//${window.location.hostname}:8000`
}